import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-tools-swiss-knife-icon',
  templateUrl: './tools-swiss-knife.component.html'
})
export class ToolsSwissKnifeComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
